export const AUTH_USER = 'AUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SIGN_OUT = 'SIGN_OUT';

export const USER_DETAILS = 'USER_DETAILS';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_AUTH = 'REFRESH_AUTH';